module.exports = __webpack_public_path__ + "img/IMG014.9e0378aa.jpg";